import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Auth, multiFactor } from '@angular/fire/auth';

/**
 * Redirects email/password users without an enrolled TOTP factor to the
 * MFA setup page. Must run AFTER authGuard in canActivate: it relies on
 * authGuard having already resolved the Firebase auth state, so a null
 * currentUser here means "unauthenticated" (authGuard handles it), not
 * "still loading".
 */
export const mfaGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  const auth = inject(Auth);
  const router = inject(Router);

  const user = auth.currentUser;
  if (!user) return true;

  const isEmailPassword = user.providerData.some(p => p.providerId === 'password');
  if (!isEmailPassword) return true;

  const enrolled = multiFactor(user).enrolledFactors.length > 0;
  if (enrolled) return true;

  return router.createUrlTree(['/auth/setup-mfa'], {
    queryParams: { returnUrl: state.url }
  });
};
